export default "__VITE_ASSET__771a9941__"